import Cookies from 'js-cookie'

const TokenKey = 'tc_token'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token, { expires: 40 })
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function clearLoginData () {
  removeToken();
  // sessionStorage.clear();
  // localStorage.clear();
  localStorage.removeItem('user_id');
}
